const GH_MENTION_BLOT_ATTRIBUTES = ["data-test-id", "data-id", "data-name", "data-email", "contenteditable"];

export const GH_BLOT_ATTRIBUTES = [...GH_MENTION_BLOT_ATTRIBUTES];
